export default __webpack_public_path__ + "static/media/bracers_of_vicious_frenzy.7483cf0d.jpg";